module.exports = __webpack_public_path__ + "static/media/V-ID-2.b567aed4.mp4";